import styled from 'styled-components';
import { Dialog } from 'components/Dialog';
import { MyPortal } from './MyPortal';

export const StyledPrintDialog = styled(Dialog)`
  width: 600px;
  z-index: 50;
  min-height: 300px;
`;

export const StyledMyPortalPrinter = styled(MyPortal)`
  margin-bottom: 20px;
`;

export const DialogContent = styled.div`
  padding: 10px;
`;

export const StyledMyPortalTrayMenu = styled(MyPortal)`
  margin-right: 10px;
  width: 48%;
  float: left;
`;

export const StyledMyPortalCopiesMenu = styled(MyPortal)`
  margin-right: 10px;
  width: 48%;
  float: left;
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
`;

export const StyledToast = styled.div`
  padding-bottom: 1em;
`;

export const Container = styled.div`
  margin: 10px;
`;
